import * as XLSX from '@e965/xlsx'
import moment from 'moment'
import { columns } from './columns'

// Campos dasométricos/numéricos que deben exportarse como celda numérica nativa
// para que Excel respete los decimales según el locale del usuario.
const NUMERIC_FIELDS = ['cap', 'dap', 'ht', 'hc', 'copaNS', 'copaEW', 'weighing']

// Columnas exportables (respeta download: false, p. ej. el id interno).
const exportColumns = columns.filter(column => column.options?.download !== false)
const orderedNames = exportColumns.map(column => column.name)
const orderedLabels = exportColumns.map(column => column.label)

// Convierte a número solo si el valor es numérico; si no, lo deja tal cual
// (p. ej. weighing puede ser "Faltan datos para calcular").
const toNumericIfPossible = value => {
  if (value === null || value === undefined || value === '') return value
  const parsed = parseFloat(value)
  return Number.isNaN(parsed) ? value : parsed
}

const buildExportRow = row =>
  orderedNames.reduce((accum, field) => {
    const value = row[field]
    accum[field] = NUMERIC_FIELDS.includes(field) ? toNumericIfPossible(value) : value
    return accum
  }, {})

export const exportReportToXlsx = (rows, selectedTenant) => {
  const exportRows = rows.map(buildExportRow)

  const worksheet = XLSX.utils.json_to_sheet(exportRows, { header: orderedNames })
  XLSX.utils.sheet_add_aoa(worksheet, [orderedLabels], { origin: 'A1' })

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte')

  const tenantName = selectedTenant?.fullName || selectedTenant?.name || 'Reporte'
  const filename = `Reporte Árboles ${moment().format('YYYY-MM-DD')} - ${tenantName}.xlsx`

  XLSX.writeFile(workbook, filename, { compression: true })
}
